import { RootState } from '../types'

export const getMainDeliverySelector = (state: RootState) => state.delivery